// extracted by mini-css-extract-plugin
export default {"card":"DocumentSource_card__9jqpe","active":"DocumentSource_active__hY+tS"};